import { render, staticRenderFns } from "./NewStoreRegist.vue?vue&type=template&id=78af666b&"
import script from "./NewStoreRegist.vue?vue&type=script&lang=js&"
export * from "./NewStoreRegist.vue?vue&type=script&lang=js&"
import style0 from "./NewStoreRegist.vue?vue&type=style&index=0&id=78af666b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports